module.exports = __webpack_public_path__ + "static/media/Ticketing-Minus-Coral.4d2a3741.svg";